import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Routes, RouterModule, mapToCanActivate } from '@angular/router';
import { AgrFilterModule, AgrPageToolbarModule } from '@next/core-lib/components';
import { AgrDatePipe } from '@next/core-lib/i18n';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { HistoryComponent } from './components/history/history.component';
import { HistoryEffects } from './store/history.effects';
import { reducer } from './store/history.reducer';
import { SharedModule } from '../shared/shared.module';
import { HistoryGuard } from './guards/history-guard';

const routes: Routes = [{ path: '', component: HistoryComponent }];

@NgModule({
  declarations: [HistoryComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      { path: '', redirectTo: 'history', pathMatch: 'full' },
      {
        path: 'history',
        children: routes,
        canActivate: mapToCanActivate([HistoryGuard]),
      },
    ]),
    AgrPageToolbarModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    AgrFilterModule,
  ],
  providers: [
    AgrDatePipe,
    provideState('historyModule', reducer),
    provideEffects([HistoryEffects]),
  ],
  exports: [],
})
export class HistoryModule {}
